import styled from "styled-components";
import { transparentize } from "polished";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    height: calc(100% - 100px);
    flex-direction: column-reverse;
    align-items: center;
`;

export const Button = styled.div`
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    div {
        display: inline-block;
    }
`;

export const Wrapper = styled.div`
    position: relative;
    img {
        display: block;
    }
`;

export const Window = styled.div`
    position: absolute;
    background-color: ${p => transparentize(1 - 0.3, p.theme.c.active)};
    box-shadow: 0 0 0 2px ${p => p.theme.c.boost} inset;
    mix-blend-mode: multiply;
`;

export const Point = styled.div`
    position: absolute;
    width: 38px;
    height: 38px;
    margin-top: -19px;
    margin-left: -19px;
    border-radius: 19px;
    background-color: ${p => p.theme.c.boost};
`;

export const DeleteButton = styled.button`
    position: absolute;
    left: 10px;
    bottom: -16px;
`;

export const Bar = styled.div`
    position: absolute;
    top: 0;
    background-color: transparent;
    box-shadow: 0 0 0 1px ${p => p.theme.c.boost} inset;
    cursor: pointer;

    &:hover {
        background-color: ${p => transparentize(1 - 0.2, p.theme.c.boost)};
    }

    &.Selected {
        background-color: ${p => transparentize(1 - 0.5, p.theme.c.boost)};

        &:hover {
            background-color: ${p => transparentize(1 - 0.7, p.theme.c.boost)};
        }
    }
`;
